export { default as TrackingTextClamp } from './tracking-text-clamp'
export type { TrackingTextClampProps } from './tracking-text-clamp'
